import React, { useEffect } from 'react';
import { Menu } from '../ui/layout/Menu';
import { InfoBox } from '../ui/InfoBox';
import { appState, userState } from '../store';
import { useSnapshot } from 'valtio';
import { FooterCmp } from '../ui/layout/Footer';
import { PageHeader } from '../ui/ds/PageHeader';
import { useSearchParams } from 'react-router-dom';
import Podium from '../ui/podium/Podium';
import {Matches} from "../ui/Matches";
import {PrizeMoney} from "../ui/PrizeMoney";

function Home() {
    const userSnap = useSnapshot(userState);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const loginModal = Boolean(searchParams.get('loginModal'));
        if (loginModal) {
            if (userSnap.isLoggedIn) {
                appState.modals.showLoginModal = false;
            } else {
                appState.modals.showLoginModal = true;
            }
            searchParams.delete('loginModal');
            setSearchParams(searchParams);
        }
    }, [userSnap.isLoggedIn]);

    return (
        <>
            <Menu />

            {!userSnap.isLoggedIn && (
                <InfoBox
                    text="Upozornění: jedná se o neveřejnou tipovací hru mezi kamarády."
                    badge="Info"
                    link="/pravidla"
                />
            )}

            <PageHeader
                title="Zápasy"
                subtitle="Tipuj výsledky a sbírej body"
                right={
                    userSnap.isLoggedIn ? (
                        <div className="text-right">
                            <div className="text-[24px] font-black text-white font-nunito leading-none">
                                {userSnap.userProfile?.points ?? 0}
                            </div>
                            <div className="text-[12px] text-white/65 font-semibold font-nunito">bodů</div>
                        </div>
                    ) : undefined
                }
            />
            <PrizeMoney showRegisterButton={!userSnap.isLoggedIn} />
            <div className="max-w-6xl mx-auto px-4 md:px-8 py-6">
                {/*<Matches />*/}
                <Podium />
            </div>

            <FooterCmp />
        </>
    );
}

export default Home;
